import {IPermissionsStoreState} from './IPermissionsStoreState';

export const permissionsInitialState: IPermissionsStoreState = {
  loading: true,
  exporting: false,
  requestTriggered: false,
  roleList: [],
};
